export const ACCESS_TOKEN = process.env.REACT_APP_API_URI_END_POINT + "_ac_tk";
export const REFRESH_TOKEN = process.env.REACT_APP_API_URI_END_POINT + "_rf_tk";
export const LAST_AUTH_USER =
  process.env.REACT_APP_COGNITO_CLIENT_ID + ".LastAuthUser";
export const USER_NAME = "_user_name";
export const USER_EMAIL = "_email";
